import { render, staticRenderFns } from "./copyright3D.vue?vue&type=template&id=979c4ff6&scoped=true&"
import script from "./copyright3D.vue?vue&type=script&lang=js&"
export * from "./copyright3D.vue?vue&type=script&lang=js&"
import style0 from "./copyright3D.vue?vue&type=style&index=0&id=979c4ff6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979c4ff6",
  null
  
)

export default component.exports